import { motion } from "framer-motion";
import { ArrowUp } from "lucide-react";

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="py-20 border-t border-white/10 bg-[#050505] relative overflow-hidden">
      {/* Huge Background Text */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <span className="text-[20vw] font-bold tracking-tighter text-white/[0.02] uppercase whitespace-nowrap">
          VAIDEHI
        </span>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Copyright */}
          <div className="text-center md:text-left">
            <p className="text-[#888888] text-sm">
              © 2026{" "}
              <span className="text-white">Vaidehi Virani</span>. All rights
              reserved.
            </p>
            <p className="text-[#888888] text-xs mt-2">
              Crafted with passion for mobile excellence
            </p>
          </div>

          {/* Back to Top */}
          <motion.button
            onClick={scrollToTop}
            data-testid="back-to-top-btn"
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.95 }}
            className="w-12 h-12 border border-white/20 flex items-center justify-center text-[#888888] hover:border-[#D4FF00] hover:text-[#D4FF00] transition-all duration-300"
            aria-label="Back to top"
          >
            <ArrowUp size={20} />
          </motion.button>
        </div>
      </div>
    </footer>
  );
};
